import { createFileRoute } from '@tanstack/react-router'
import SettingsSecretsPage from '@/components/pages/Settings/team/SettingsSecretsPage/SettingsSecretsPage'
import { z } from 'zod'

const secretsSearchSchema = z.object({
  page: z.number().optional(),
})

export const Route = createFileRoute('/$workspaceName/$environment/team-settings/secrets')({
  validateSearch: (search) => secretsSearchSchema.parse(search),
  component: SecretsSettingsRoute,
})

function SecretsSettingsRoute() {
  return <SettingsSecretsPage />
}
